var avatar = {
  sizes: {
    xSmall: {
      width: '16px',
      height: '16px',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '12px'
    },
    small: {
      width: '24px',
      height: '24px',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '12px'
    },
    medium: {
      width: '32px',
      height: '32px',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px'
    },
    large: {
      width: '48px',
      height: '48px',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px'
    },
    xLarge: {
      width: '64px',
      height: '64px',
      fontWeight: 300,
      fontSize: '32px',
      lineHeight: '34px'
    }
  }
};
export default avatar;